export enum UploadFileStatusEnum {
  Uploading = 'uploading',
  Uploaded = 'uploaded',
  Failed = 'failed',
}
